import { supabase } from "@/lib/supabase";
import { getToken, setToken } from "./authToken";

const DELETE_IDEMPOTENCY_KEY = "scrolled-account-deletion-idempotency-key";

const createIdempotencyKey = () => {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  return `delete-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const getDeletionIdempotencyKey = () => {
  const existing = sessionStorage.getItem(DELETE_IDEMPOTENCY_KEY);
  if (existing) return existing;

  const created = createIdempotencyKey();
  sessionStorage.setItem(DELETE_IDEMPOTENCY_KEY, created);
  return created;
};

export const clearDeletionState = () => {
  sessionStorage.removeItem(DELETE_IDEMPOTENCY_KEY);
};

export const getCurrentAccessToken = async () => {
  const { data, error } = await supabase.auth.getSession();
  if (!error && data?.session?.access_token) {
    setToken(data.session.access_token);
    return data.session.access_token;
  }

  const storedToken = getToken();
  if (storedToken) return storedToken;
  throw new Error("SESSION_REQUIRED");
};
